export const isNotificationSeen = (data, readNotifications) => {
  return data?.is_seen || readNotifications.includes(data?.id)
}
